// Use Shopify's section rendering and Dawn's standard cart events for drawer actions.
window.SteadiaCart = window.SteadiaCart || {
  busy: false,
  async mutate(endpoint, values, source) {
    const drawer = source.closest('cart-drawer');
    if (!drawer || this.busy) return false;
    // Protection can connect before Dawn's deferred drawer script has upgraded it.
    await customElements.whenDefined('cart-drawer');
    if (!source.isConnected || this.busy) return false;
    this.busy = true;
    const controls = [...drawer.querySelectorAll('button, input')];
    const disabled = controls.map((control) => control.disabled);
    controls.forEach((control) => { control.disabled = true; });
    const activeAction = source.querySelector('[data-cart-action]')?.dataset.cartAction;
    const lineInput = drawer.querySelector(`#Drawer-quantity-${values.line}`);
    const variantId = values.id?.split(':')[0] || lineInput?.dataset.quantityVariantId;
    const lineKey = values.id?.includes(':') ? values.id : lineInput?.dataset.quantityLineKey;
    const action = values.quantity === 0 ? 'remove' : endpoint === routes.cart_add_url ? 'add' : 'update';
    let deferred;
    let success = false;
    try {
      const response = await fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          ...values,
          sections: drawer.getSectionsToRender().map((section) => section.id),
          sections_url: window.location.pathname,
        }),
      });
      const cart = await response.json();
      if (!response.ok || cart.errors || cart.status) {
        throw new Error(cart.description || (typeof cart.errors === 'string' ? cart.errors : '') || 'Please try again. Your cart could not be updated.');
      }
      // The add endpoint returns the added line; fetch totals for the standard event.
      const fullCart = cart.items && cart.currency ? cart : await CartItems.fetchCartData();
      const { CartLinesUpdateEvent } = window.StandardEvents || {};
      if (CartLinesUpdateEvent && fullCart?.currency && (action === 'add' ? variantId : lineKey)) {
        deferred = CartLinesUpdateEvent.createPromise();
        source.dispatchEvent(new CartLinesUpdateEvent({
          action,
          context: 'cart',
          lines: action === 'add' ? [{ merchandiseId: variantId, quantity: values.quantity }] : [{ id: lineKey, quantity: values.quantity }],
          promise: deferred.promise,
        }));
        deferred.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(fullCart) });
      }
      drawer.classList.toggle('is-empty', fullCart?.item_count === 0);
      drawer.renderContents(cart);
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: fullCart });
      const focus = drawer.querySelector(`[data-cart-action="${activeAction}"]`) || drawer.querySelector('.drawer__close');
      trapFocus(drawer.querySelector('.drawer__inner'), focus);
      success = true;
      return true;
    } catch (error) {
      const message = source.querySelector('[data-cart-action-error], [data-protection-error]');
      if (message) { message.textContent = error.message; message.hidden = false; }
      deferred?.reject(error);
      return false;
    } finally {
      controls.forEach((control, index) => { if (control.isConnected) control.disabled = disabled[index]; });
      this.busy = false;
      // A re-render can reveal orphaned protection while another action is still busy.
      document.dispatchEvent(new CustomEvent('steadia:cart-idle', { detail: { success } }));
    }
  },
  bindForm(source) {
    source.querySelector('form')?.addEventListener('submit', async (event) => {
      if (!source.closest('cart-drawer')) return;
      event.preventDefault();
      const form = event.currentTarget;
      const values = Object.fromEntries(new FormData(form));
      delete values.return_to;
      ['line', 'quantity', 'selling_plan'].forEach((key) => { if (key in values) values[key] = Number(values[key]); });
      const endpoint = new URL(form.action).pathname.endsWith('/add') ? routes.cart_add_url : routes.cart_change_url;
      await this.mutate(endpoint, values, source);
    });
  },
};

if (!customElements.get('steadia-cart-action')) {
  customElements.define('steadia-cart-action', class extends HTMLElement {
    connectedCallback() { window.SteadiaCart.bindForm(this); }
  });
}
